import React from 'react'

const Loader = () => {
    return (
        <div className="loader_wrpr">
            <div className="loader">
                <div className="orbe" style={{ '--index': 0 }} />
                <div className="orbe" style={{ '--index': 1 }} />
                <div className="orbe" style={{ '--index': 2 }} />
                <div className="orbe" style={{ '--index': 3 }} />
                <div className="orbe" style={{ '--index': 4 }} />
            </div>
        </div>
    )
}

export default Loader